import React, { useState, useEffect } from 'react';
import { useUnits } from '../../context/unitsContext';
import useSubmitLock from '../../utils/useSubmitLock';

function EditUnit({ onCloseModal, onSaveSuccess, unitId }) {
  const { getUnitById, updateUnit, listThirdPartyServices } = useUnits();

  const [thirdPartyServices, setThirdPartyServices] = useState([]);
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  const [unitData, setUnitData] = useState({
    city: "",
    address: "",
    phone: "",
    institutional_email: "",
    name: "",
    acronym: "",
    original_destination: "",
    type_of_establishment: "",
    establishment_management: "",
    third_party_services: [],
    opening_date: "",
    finality: "",
    internal_regulations: false,
    own_internal_regime: false,
    accessibility: false,
    unused_space: false,
  });

  useEffect(() => {
    const fetchUnitData = async () => {
      const unit = await getUnitById(unitId);
      if(unit) {
        unit.opening_date = unit.opening_date.split('T')[0];
        setUnitData(unit);
      }
    };

    const fetchThirdPartyServices = async () => {
      const servicesData = await listThirdPartyServices();
      if(servicesData) {
        setThirdPartyServices(servicesData.results || []);
      } else {
        console.error('Erro ao buscar os serviços de terceiros:');
      }
    };

    fetchUnitData();
    fetchThirdPartyServices();
  }, [getUnitById, unitId, listThirdPartyServices]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;
    setUnitData(prevState => ({
      ...prevState,
      [name]: newValue
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await runWithSubmitLock(async () => {
      const updatedData = {
        ...unitData,
        third_party_services: unitData.third_party_services.map(service => service.id)
      };

      await updateUnit(unitId, updatedData);
      if (updateUnit) {
        onSaveSuccess();
        onCloseModal();
      }
    });
  };

  const handleAddService = (service) => {
    if (!unitData.third_party_services.map(s => s.id).includes(service.id)) {
      setUnitData(prevState => ({
        ...prevState,
        third_party_services: [...prevState.third_party_services, service]
      }));
    }
  };

  const handleRemoveService = (service) => {
    setUnitData(prevState => ({
      ...prevState,
      third_party_services: prevState.third_party_services.filter(s => s.id !== service.id)
    }));
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="form-group modal-form">
          <label htmlFor="name">Nome:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={unitData.name || ''}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="acronym">Sigla:</label>
          <input
            type="text"
            id="acronym"
            name="acronym"
            value={unitData.acronym || ''}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="city">Cidade:</label>
          <input
            type="text"
            id="city"
            name="city"
            value={unitData.city || ''}
            onChange={handleChange}
          />
        </div>
        <div className="form-group modal-form">
          <label htmlFor="address">Endereço:</label>
          <input
            type="text"
            id="address"
            name="address"
            value={unitData.address || ''}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Telefone:</label>
          <input
            type="text"
            id="phone"
            name="phone"
            value={unitData.phone || ''}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="institutional_email">Email Institucional:</label>
          <input
            type="text"
            id="institutional_email"
            name="institutional_email"
            value={unitData.institutional_email || ''}
            onChange={handleChange}
          />
        </div>
        <div className="form-group modal-form">
          <label htmlFor="original_destination">Género: </label>
          <select
            id="original_destination"
            name='original_destination'
            value={unitData.original_destination || ''}
            onChange={handleChange}
          >
            <option>Selecione</option>
            <option value="Masculino">Masculino</option>
            <option value="Feminino">Feminino</option>
            <option value="Misto">Misto</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="type_of_establishment">Tipo: </label>
          <select
            id="type_of_establishment"
            name='type_of_establishment'
            value={unitData.type_of_establishment || ''}
            onChange={handleChange}
          >
            <option>Selecione</option>
            <option value="Recolhimento de presos provisórios">Provisório</option>
            <option value="Cumprimento de pena em regime fechado">Regime Fechado</option>
            <option value="Cumprimento de pena em regime semiaberto">Regime Semiaberto</option>
            <option value="Cumprimento de pena em regime aberto ou de limitação de fim de seman">Regime aberto Limitado FDS</option>
            <option value="Cumprimento de medida de segurança de internação ou tratamento ambulatorial">Medida Segurança/Tratamento</option>
            <option value="Realização de exames gerais e criminológico">Realização de Exames</option>
            <option value="Prestar assistência aos albergados e aos egressos">Prestar Assitenência Albergado/Regresso</option>
            <option value="Diversos tipos de regime">Diversos tipos de Regime</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="establishment_management">Tipo de Gestão: </label>
          <select
            id="establishment_management"
            name='establishment_management'
            value={unitData.establishment_management || ''}
            onChange={handleChange}
          >
            <option>Selecione</option>
            <option value="Pública">Pública</option>
            <option value="Parceria Público-Privada">Pública/Privada</option>
            <option value="Co-gestão">Co-gestão</option>
            <option value="Organizações sem fins lucrativos">ONG</option>
          </select>
        </div>
        <div className="form-group modal-form">
          <label htmlFor="opening_date">Data de Abertura:</label>
          <input
            type="date"
            id="opening_date"
            name="opening_date"
            value={unitData.opening_date || ''}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="internal_regulations">Possui regimento interno: </label>
          <select
            id="internal_regulations"
            name='internal_regulations'
            value={unitData.internal_regulations !== undefined ? unitData.internal_regulations.toString() : 'false'}
            onChange={handleChange}
          >
            <option>Selecione</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="own_internal_regime">Próprio ou geral: </label>
          <select
            id="own_internal_regime"
            name='own_internal_regime'
            value={unitData.own_internal_regime !== undefined ? unitData.own_internal_regime.toString() : 'false'}
            onChange={handleChange}
          >
            <option>Selecione</option>
            <option value="true">Regimento próprio</option>
            <option value="false">Regimento Geral</option>
          </select>
        </div>
        <div className="form-group modal-form">
          <label htmlFor="finality">Finalidade da Construção:</label>
          <select
            id="finality"
            name="finality"
            value={unitData.finality || ''}
            onChange={handleChange}
          >
            <option>Selecione</option>
            <option value="Concebido">Concebido como estabeleciomento penal</option>
            <option value="Adaptado">Adaptado para estabeleciomento penal</option>
          </select>
        </div>
        <div className="form-group modal-form">
          <label htmlFor="accessibility">Possui acessibilidade:</label>
          <select
            id="accessibility"
            name="accessibility"
            value={unitData.accessibility !== undefined ? unitData.accessibility.toString() : 'false'}
            onChange={handleChange}
          >
            <option>Selecione</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>
        <div className='checkbox-container'>
          <h3>Serviço Tercerizado:</h3>
          <div>
            <div className="box">
              <div className="existing-services">
                <h5 className='h4-title'>Click para dicionar</h5>
                <ul>
                {thirdPartyServices.map(service => (
                  <li key={service.id} onClick={() => handleAddService(service)}>
                    {service.type}
                  </li>
                ))}
              </ul>
            </div>
            <div className="added-services">
              <h5 className='h4-title'>Clique para remover</h5>
              <ul>
                {unitData.third_party_services.map(service => (
                  <li key={service.id} onClick={() => handleRemoveService(service)}>
                    {service.type}
                  </li>
                ))}
              </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Adicione mais campos conforme necessário */}
        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Salvando...' : 'Salvar'}
        </button>
      </form>

    </div>
  );
}

export default EditUnit;
